/**
 * List Schema of CargaFoto
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'

/* TODO: review generated schema */
export class ListCargaFotoSchema extends Schema {
  readonly name = 'ListCargaFoto'

  readonly fieldSet: FieldSet<CargaFoto> = {
    idFotoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    urlImagem: (schema): FieldComponent => ({
      is: Component.RenderImage,
      bind: {
        src: schema.model.urlImagem,
        alt: this.translateFrom(schema.fieldName),
        innerClass: 'w-50 h-50',
      },
    }),
    ehOcorrencia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ehOcorrencia),
      },
    }),
    reprocessar: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.reprocessar),
      },
    }),
    urlBackup: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
